<template>
  <div class="q-gutter-sm container-adiciona">
    <!--<q-btn
      label="Adicionar Atividade"
      color="primary"
      no-caps
      dense
      icon="add_circle_outline"
      class="btn-adiciona"
      @click="incluir = true"
      />
    -->

    <q-dialog v-model="incluir">
      <q-card style="width: 1400px; max-width: 80vw">
        <q-card-section class="row items-center q-pb-none q-mb-lg">
          <div class="text-h6 text-weight-bold text-brand-5">
            Adicionar Pergunta de Avaliação de Risco
          </div>
          <q-space />
          <q-btn
            icon="close"
            flat
            round
            dense
            v-close-popup
            @click="$emit('closing')"
          />
        </q-card-section>

        <q-card-section class="q-mb-lg">
          <q-table
            style="height: 400px"
            :rows="listaAtividades"
            dense
            :columns="columns"
            row-key="atividadeId"
            class="tabela-tamanho-fixo"
            selection="multiple"
            @selection="(details) => onSelect(details)"
            v-model:selected="selected"
            :rows-per-page-options="[0]"
            virtual-scroll
            table-header-class="text-weight-bold"
            hide-bottom
            flat
          >
            <template v-slot:header-selection="scope">
              <q-checkbox v-model="scope.selected" />
            </template>

            <template v-slot:body-selection="scope">
              <q-checkbox
                :disable="scope.row.obrigatorio"
                v-model="scope.selected"
              />
            </template>
            <template v-slot:body-cell-nome="props">
              <q-td :props="props">
                <div class="text-brand-5 text-weight-medium">
                  {{ props.row.nome }}
                </div>
              </q-td>
            </template>
            <template v-slot:body-cell-critico="props">
              <q-td :props="props">
                <div
                  v-if="props.row.critico"
                  class="row align items-center"
                  style="
                    width: fit-content;
                    background: #e8ffec;
                    padding: 2px 5px;
                  "
                >
                  <span class="elipse q-mr-sm bg-positive" />
                  <div
                    style="width: fit-content"
                    class="text-bold text-brand-5"
                  >
                    {{ "Sim" }}
                  </div>
                </div>
                <div
                  v-else
                  class="row align items-center"
                  style="
                    width: fit-content;
                    background: #ffe9e9;
                    padding: 2px 5px;
                  "
                >
                  <span class="elipse q-mr-sm bg-red" />
                  <div
                    style="width: fit-content; color: #850202"
                    class="text-bold"
                  >
                    {{ "Não" }}
                  </div>
                </div>
              </q-td>
            </template>
            <template v-slot:body-cell-obrigatorio="props">
              <q-td :props="props">
                <div
                  v-if="props.row.obrigatorio"
                  class="row align items-center"
                  style="
                    width: fit-content;
                    background: #e8ffec;
                    padding: 2px 5px;
                  "
                >
                  <span class="elipse q-mr-sm bg-positive" />
                  <div
                    style="width: fit-content"
                    class="text-bold text-brand-5"
                  >
                    {{ "Sim" }}
                  </div>
                </div>
                <div
                  v-else
                  class="row align items-center"
                  style="
                    width: fit-content;
                    background: #ffe9e9;
                    padding: 2px 5px;
                  "
                >
                  <span class="elipse q-mr-sm bg-red" />
                  <div
                    style="width: fit-content; color: #850202"
                    class="text-bold"
                  >
                    {{ "Não" }}
                  </div>
                </div>
              </q-td>
            </template>
          </q-table>
        </q-card-section>

        <q-card-actions class="q-mb-md" align="right">
          <q-btn
            label="Confimar Avaliação"
            no-caps
            color="positive"
            @click="$emit('closing')"
            v-close-popup
            icon="check_circle_outline"
          />
        </q-card-actions>
      </q-card>
    </q-dialog>
  </div>
</template>

<script>
import { ref } from "@vue/reactivity";
import { onMounted } from "@vue/runtime-core";
import { useStore } from "vuex";
import { useQuasar } from "quasar";

const columns = [
  {
    name: "checkobox",
    label: "",
    align: "left",
  },
  {
    name: "nome",
    label: "Nome da Atividade",
    align: "left",
    field: (row) => row.nome,
    format: (val) => `${val}`,
    sortable: true,
  },
  {
    name: "critico",
    align: "left",
    label: "Atividade Crítica?",
    field: "critico",
    sortable: false,
  },
  {
    name: "obrigatorio",
    align: "left",
    label: "Atividade Obrigatória?",
    field: "obrigatorio",
    sortable: false,
  },
];

export default {
  props: ["pt"],
  emits: ["closing"],
  setup(props) {
    let incluir = ref(false);
    let listaAtividades = ref([]);
    const selected = ref();
    const quasar = useQuasar();

    const store = useStore();
    let getAtividadesPorUnidade = async (rowsPerPage = 100, page = 0) => {
      if (props.pt.respostasAtividades) {
        selected.value = props.pt.respostasAtividades;
      }
      try {
        let resposta = await store.dispatch("pdt/buscarDetalheUnidade", {
          unidadeId: props.pt.unidadeId,
          perPage: rowsPerPage,
          page: page,
        });

        listaAtividades.value = resposta.data.resultado.dados;
      } catch (error) {
        console.error(error);
      }
    };

    onMounted(getAtividadesPorUnidade);
    let onSelect = async (details) => {
      const list = [];
      if (details.added) {
        details.rows.forEach((element) => {
          list.push(adicionarAtividade(element.atividadeId));
        });
      } else {
        const atividadesObrigatorias = details.rows.filter(
          (row) => row.obrigatorio
        );

        if (atividadesObrigatorias.length > 0) {
          quasar.notify({
            message: `Não é possível remover atividades obrigatórias: ${atividadesObrigatorias
              .map((a) => a.nome)
              .join(", ")}`,
            color: "negative",
            icon: "warning",
            timeout: 5000,
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });

          setTimeout(() => {
            atividadesObrigatorias.forEach((atividade) => {
              if (
                !selected.value.find(
                  (s) => s.atividadeId === atividade.atividadeId
                )
              ) {
                selected.value.push(atividade);
              }
            });
          }, 100);

          const atividadesNaoObrigatorias = details.rows.filter(
            (row) => !row.obrigatorio
          );
          atividadesNaoObrigatorias.forEach((element) => {
            list.push(removerAtividade(element.atividadeId));
          });
        } else {
          details.rows.forEach((element) => {
            list.push(removerAtividade(element.atividadeId));
          });
        }
      }
      await Promise.all(list);
    };

    let adicionarAtividade = async (atividadeId) => {
      return store.dispatch("pdt/adicionarAtividadePt", {
        atividadeId,
        ptId: props.pt.ptId,
        resposta: true,
      });
    };

    let removerAtividade = async (atividadeId) => {
      return store.dispatch("pdt/removerAtividadePt", {
        atividadeId,
        ptId: props.pt.ptId,
        resposta: true,
      });
    };

    return {
      incluir,
      columns,
      listaAtividades,
      selected,
      getAtividadesPorUnidade,
      onSelect,
    };
  },
};
</script>

<style scoped>
elipse {
  width: 12px;
  height: 12px;
  border-radius: 50%;
}
@media (max-width: 600px) {
  .container-adiciona {
    margin-left: 0px;
  }
  .btn-adiciona {
    font-size: 11px;
  }
}
</style>
